/**************************************************
 * Nombre:       Apartado_Video
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {theme} from "../../Tema";
import {Apartado_Video_Dos} from "./Apartado_Video_Dos";


const Apartado_Video = ({item, setTermino, termino,click}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', px: 2}}>
                <Typography
                    sx={{
                        fontWeight: 600,
                        textAlign: 'center',
                        fontSize: sCell ? 18 : 24,
                        lineHeight: 1.2,
                        color: '#C8B0EB'
                    }}>
                    {`${item.numero} de 3`}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', mt: 2, px: 2}}>
                <Typography
                    sx={{
                        fontWeight: 600,
                        textAlign: 'center',
                        fontSize: sCell ? 18 : 24,
                        lineHeight: 1.2,
                        color: '#fff',
                        textTransform: 'uppercase'
                    }}>
                    {item.titulo}
                    <br/>
                    <span style={{color: theme.palette.secondary.main}}>{item.resaltado}</span>
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 5}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 6, px: sCell ? 1 : 0}}>
                <Apartado_Video_Dos url={item.video} posterUrl={''}  setTermino={setTermino} item={item} termino={termino} click={click}/>
            </Grid>

        </Grid>
    )

}
export default Apartado_Video    